import FormControl from '@material-ui/core/FormControl'
import RadioGroup from '@material-ui/core/RadioGroup'
import * as React from 'react'
import { forwardRef } from 'react'

import { HandlerOf } from '../../helpers/typeHelper'
import { YesNo } from '../../models'
import { Box } from '../Box/Box'
import { ErrorMessage, FormControlLabelStyled, Label, Notice, StyledRadio } from './RadioButtonGroup.styles'

interface OptionType {
  label: React.ReactNode
  subLabel?: React.ReactNode
  value: string
}

export interface RadioButtonGroupProps {
  value?: string | YesNo | null
  onChange?: HandlerOf<React.ChangeEvent<HTMLInputElement>>
  options: Array<OptionType>
  label?: string
  notice?: React.ReactNode
  row?: boolean
  width?: string
  noMargin?: boolean
  inLine?: boolean
  error?: React.ReactElement | string | boolean
  isDisabled?: boolean
}

export const RadioButtonGroup = forwardRef(
  (
    {
      value,
      onChange,
      options,
      label,
      error,
      notice,
      row = false,
      noMargin = false,
      inLine = false,
      width = '',
      isDisabled = false,
    }: RadioButtonGroupProps,
    ref
  ) => {
    const hasError = Boolean(error)

    const inLineStyles = inLine
      ? { display: 'grid', gridTemplateColumns: '1fr auto', alignItems: 'center' }
      : {}

    return (
      <FormControl
        style={{ marginBottom: noMargin ? 0 : '30px', width, ...inLineStyles }}
        component="fieldset"
        error={hasError}
      >
        <Label>{label}</Label>
        {notice && <Notice>{notice}</Notice>}
        <RadioGroup value={value} onChange={onChange} row={row} ref={ref}>
          {options.map((option: OptionType) => (
            <React.Fragment key={option.value}>
              <FormControlLabelStyled
                key={option.value}
                disabled={isDisabled}
                value={option.value}
                label={option.label}
                control={<StyledRadio $error={hasError} disabled={isDisabled} />}
              />
              {option.subLabel && <Box ml={3.5}>{option.subLabel}</Box>}
              {!row && <Box mt={0.5} />}
            </React.Fragment>
          ))}
        </RadioGroup>
        {error && error !== true && <ErrorMessage>{error}</ErrorMessage>}
      </FormControl>
    )
  }
)
